const routes = [
    {
        path: '/emissor/relatorios_conhecimentos',
        alias: [
            '/emissor/relatorios_conhecimentos/index',
            '/emissor/relatorio/conhecimentos',
            '/emissor/relatorio/conhecimentos/index'
        ],
        component: () => import('../views/Listar')
    },
    {
        name: 'formularioRelatoriosConhecimentos',
        path: '/emissor/relatorios_conhecimentos/conhecimentos',
        component: () => import('../views/Conhecimentos')
    },
    {
        path: '/emissor/relatorios_conhecimentos/nfe-cte',
        component: () => import('../views/NfeCte')
    },
    {
        name: 'impressaoRelatorio',
        path: '/emissor/relatorios_conhecimentos/:tipo/gerar',
        component: () => import('@/shared/components/ui/Relatorio')
    }
]

export default routes